import { Alert, Box, Snackbar } from '@mui/material';
import { NotificationText } from '@/data/context/notifications';
import { snackBarSX } from '@/components/content/Notifications/styles/snackbar';
import { alertSX } from '@/components/content/Notifications/styles/alert';
interface NotificationModalProps {
	id: string;
	message?: NotificationText;
	mobile: boolean;
	onClear: () => void;
}

export const DpSnackbar: React.FC<NotificationModalProps> = ({ message, onClear }) => (
	<Snackbar
		open={message ? true : false}
		anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
		autoHideDuration={5000}
		onClose={onClear}
		ClickAwayListenerProps={{
			onClickAway: onClear,
			mouseEvent: 'onMouseDown',
		}}
		sx={snackBarSX}
	>
		<Box>
			<Box>
				<Alert severity={'success'} onClose={onClear} sx={alertSX} icon={false}>
					{message}
				</Alert>
			</Box>
		</Box>
	</Snackbar>
);
